<template>
  <div class="wrapper">
    <div class="loading-wrapper">
      <vue-loading
        loader="bars"
        :active="fetchLoading"
        color="#EE6090"
        :size="{ width: '50px', height: '50px' }"
      />
    </div>

    <div class="header_wrapper">
      <v-toolbar color="primary" dark>
        <!-- 左 -->
        <div style="width: 48px;" class="d-flex justify-start">
          <v-btn @click="routerBack" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>

        <!-- 中央 -->
        <v-toolbar-title
          style="position:absolute; left:50%; transform:translateX(-50%); margin:0;"
        >
          請求書
        </v-toolbar-title>

        <!-- 右（ダミー） -->
        <div style="width: 48px;" class="d-flex justify-end">
          <v-btn icon disabled style="visibility: hidden">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>
      </v-toolbar>
    </div>

    <v-list density="compact" style="margin-top: 4px;">
      <!-- 1. key は template タグに移動し、v-list-item-group は削除 -->
      <template v-for="(c, index) in children" :key="c.childId">
        
        <v-list-item
          @click="to(c.childId, c.lastName + c.firstName)"
        >
          <!-- 2. 左側の画像: prepend スロット + v-avatar -->
          <template v-slot:prepend>
            <v-avatar class="ml-2">
              <v-img
                :src="c.imageUrl ? c.imageUrl : 'https://via.placeholder.com/240x180?text=Sample+Image+1'"
              />
            </v-avatar>
          </template>

          <!-- 3. 中央のテキスト: v-list-item-content 廃止 → title を直下に配置 -->
          <v-list-item-title v-text="c.lastName + c.firstName"></v-list-item-title>

          <!-- 4. 右側のバッジ: append スロットを使用 -->
          <template v-slot:append>
            <div class="pt-1">
              <v-badge
                v-if="c.noneRead"
                dot
                color="red"
                inline
              ></v-badge>
            </div>
          </template>
        </v-list-item>

        <v-divider />
      </template>
    </v-list>

  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import { meModule } from '@/store/entityModules/me';
import { familyModule } from '@/store/entityModules/family';
import { invoiceModule } from '@/store/entityModules/invoice';

export default defineComponent({
  components: {
    'vue-loading': Loading,
  },


  data: () => ({
    fetchLoading: true,
    children: [] as any[],
  }),
  computed: {
    family() {
      return familyModule.family || null;
    },
  },

  methods: {
    routerBack() {
      this.$router.replace('/setting');
    },
    to(childId: string, childName: string) {
      this.$router.push({ name: 'Invoice', query: {
        childId,
        childName,
      } });
    },
  },
  async mounted() {
    this.fetchLoading = true;

    // family が入るまで最大 50秒間（500ms × 100回）待機する
    let retryCount = 0;
    while (!this.family && retryCount < 100) {
      await new Promise(resolve => setTimeout(resolve, 500));
      retryCount++;
    }
    if (this.family) {
      const familyChildren = this.family.children;
  
      const fetchPromises = familyChildren.map(async (child, index) => {
        const childId = Number(child.childId);
        if (isNaN(childId)) return;

        await invoiceModule.fetchInvoices({ childId: childId, year: null });

        const invoices = invoiceModule.invoices || [];
        const hasUnread = invoices.some(inv => !inv.readDate);
    
        return { index, hasUnread };
      });

      const results = await Promise.all(fetchPromises);

      results.forEach(res => {
        if (res) {
          (familyChildren[res.index] as any).noneRead = res.hasUnread;
        }
      });

      this.children = familyChildren;
    }
    this.fetchLoading = false;
  },
});
</script>
<style lang="scss" scoped>
/* ===== レイアウト ===== */
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ===== ヘッダー ===== */
.header_wrapper {
  height: 56px;
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
.content_wrapper {
  min-height: calc(100% - 56px);
  overflow-y: hidden;
}
</style>
